import React from "react";

const TableSkeleton = ({ rows = 10, columns = 10 }) => {
  return (
    <div className="animate-pulse">
      {/* Table Header Skeleton */}
      <div className="flex gap-4 px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-[#f9fbfd] to-white">
        {Array.from({ length: columns }).map((_, index) => (
          <div
            key={`header-${index}`}
            className="h-4 bg-gray-200 rounded flex-1"
          ></div>
        ))}
      </div>

      {/* Table Body Skeleton */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className={`flex gap-4 px-6 py-4 border-b border-gray-100 ${
            rowIndex % 2 === 0 ? "bg-white" : "bg-[#f9fbfd]/40"
          }`}
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={`cell-${rowIndex}-${colIndex}`}
              className="h-4 bg-gray-200 rounded flex-1"
            ></div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
